// extracted by mini-css-extract-plugin
module.exports = {"Container":"Table_Container__tKUSF","Content":"Table_Content__lfELq"};